import { Box, Container } from '@mui/material'
import React, { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import { epgPagePath } from '@/shared/constants/epgConstants'
import { vodPagePath } from '@/shared/constants/vodConstants'
import { homePagePath } from '@/shared/constants/homeConstants'
import { useMainScreenLogic } from '@/pages/mainScreen/model'
import { ContentSuspense } from '@/shared/ui/ContentSuspense'
import { GetVODDetailsProvider } from '@/features/VOD/context'
import HomeContent from '@/pages/home/HomeContent'
import {
    faqPagePath,
    profilePagePath,
    settingsPagePath,
    TCPage,
    termsOfServicePagePath,
} from '@/shared/constants'
import { ProfilePage } from '../Profile/ProfilePage'
import { SettingsPage } from '../Settings/SettingsPage'
import { FAQ } from '../FAQ/FAQ'
import { TermsAndConditions } from '@/features/termsAndConditions/ui/TermsAndConditions'
import { TermsOfService } from '../TermsOfService/TermsOfService'
import CookiesModal from '@/pages/mainScreen/CookiesModal'
import { seriesPagePath } from '@/shared/constants/seriesConstants'
import { isSmartTV, isStreamIQ, isToya } from '@/shared/lib'
import { getGetSeriesContentModule } from '@/shared/getContainer/getGetSeriesContentModule'
import { HomeContentTV } from '@/appTV/HomeContentTV'
import { VodContentProvider } from '@/features/VOD/context/UseGetVodContextContext/VodContentContext'

const SeriesContentModule = await getGetSeriesContentModule()
const SeriesContent = SeriesContentModule

const TvContent = lazy(() => import('../../components/tv/components/TvContent'))
const EpgContent = lazy(
    () => import('../../components/epg/components/EpgContent')
)
const VodContent = lazy(
    () => import('../../features/VOD/components/VodContent')
)

export const MainScreen = (): JSX.Element => {
    const {
        isTVisible,
        isVodContentVisible,
        pathname,
        isVodContentPlaying,
        openModal,
        handleClose,
    } = useMainScreenLogic()

    const mainScreenContainerStyle = {
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        transition: 'background-image 0.5s ease-in-out',
        maxHeight: '100%',
        height: '100%',
        overflow: { xs: 'auto', sm: 'hidden' },
        position: 'relative',
    }

    return (
        <Box sx={mainScreenContainerStyle}>
            <Box
                sx={{
                    position: !isVodContentVisible ? 'relative' : 'static',
                }}>
                {isTVisible && !isVodContentPlaying && (
                    <Container maxWidth="xl" disableGutters>
                        <TvContent />
                    </Container>
                )}

                <ContentSuspense actualPath={pathname}>
                    <Routes>
                        <Route
                            path={homePagePath}
                            element={
                                <GetVODDetailsProvider>
                                    {isSmartTV() ? (
                                        <HomeContentTV />
                                    ) : (
                                        <HomeContent />
                                    )}
                                </GetVODDetailsProvider>
                            }
                        />

                        {isStreamIQ() && (
                            <Route
                                path={seriesPagePath}
                                element={
                                    <GetVODDetailsProvider>
                                        <VodContentProvider>
                                            <SeriesContent />
                                        </VodContentProvider>
                                    </GetVODDetailsProvider>
                                }
                            />
                        )}
                        <Route
                            path={epgPagePath}
                            element={
                                <Container maxWidth="xl" disableGutters>
                                    <EpgContent />
                                </Container>
                            }
                        />
                        <Route
                            path={vodPagePath}
                            element={
                                <GetVODDetailsProvider>
                                    <VodContentProvider>
                                        <VodContent />
                                    </VodContentProvider>
                                </GetVODDetailsProvider>
                            }
                        />
                        <Route
                            path={profilePagePath}
                            element={
                                <Container maxWidth="xl" disableGutters>
                                    <ProfilePage />
                                </Container>
                            }
                        />
                        <Route
                            path={settingsPagePath}
                            element={
                                <Container maxWidth="xl" disableGutters>
                                    <SettingsPage />
                                </Container>
                            }
                        />
                        <Route
                            path={faqPagePath}
                            element={
                                <Container maxWidth="xl" disableGutters>
                                    <FAQ />
                                </Container>
                            }
                        />
                        <Route
                            path={TCPage}
                            element={
                                <Container maxWidth="xl" disableGutters>
                                    <TermsAndConditions />
                                </Container>
                            }
                        />
                        <Route
                            path={termsOfServicePagePath}
                            element={
                                <Container maxWidth="xl" disableGutters>
                                    <TermsOfService />
                                </Container>
                            }
                        />
                    </Routes>
                </ContentSuspense>
            </Box>
            {isToya() && (
                <CookiesModal open={openModal} handleClose={handleClose} />
            )}
        </Box>
    )
}
